module.exports = __webpack_public_path__ + "media/img/uploads/press-news-thumb-03-8b5f92e166dfbe0e3990aef00aa2e0ef.jpg";